<div class="courses-panel">
  <!-- Mensaje de sesión expirada -->
  <div *ngIf="sessionExpired" class="session-expired-alert">
    <pichincha-typography
      variant="prelo"
      color="bp-semantic-error700"
      weight="700"
      size="16px"
      lineHeight="20px"
      spacing="1.5"
      category="p"
      align="center"
    >
       {{ sessionExpiredMessage }}
    </pichincha-typography>
  </div>
  <div class="header">
    <pichincha-typography
    variant="prelo-slab"
    color="bp-primary-blue500"
    weight="900"
    size="18px"
    lineHeight="20px"
    spacing="1.5"
    category="h1"
    tabIndexElement="2"
    align="center"
  >
  Consulta Grabaciones Históricas Banco Pichincha
  </pichincha-typography>
  </div>
<div>
  <record-card-list>
  </record-card-list>
  </div>
</div>


